//import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import AntiForgeryTokenComponent from './js/anti-forgery-token.component';

ComponentsFactory.getInstance().define('anti-forgery-token', AntiForgeryTokenComponent);
